import { IconCheck } from '../QuirkIcons';
import styles from './PollRadioButton.module.css';

interface PollRadioButtonProps {
	onClick?: () => void;
	disabled?: boolean;
	checked?: boolean;
}

export const PollRadioButton: React.FC<PollRadioButtonProps> = ({ onClick, disabled, checked = false }) => {
	const handleSelected = () => {
		if (!disabled) {
			onClick && onClick();
		}
	};

	return (
		<div className={styles.voteButtonContainer} onClick={handleSelected}>
			<div className={styles.voteButton}>
				<span style={{ opacity: checked ? 1 : 0 }} className="iconCircle">
					<IconCheck />
				</span>
			</div>
		</div>
	);
};
